import { Badge, Tooltip } from '@mantine/core';
import { formatPct, formatSignedKg, severityColor, varianceSeverity } from '../utils';

/** Visual variance highlight shared by the silo-reading and stock-count screens
 * (BUILD_SPEC.md §8.2/§8.6: "variance highlighted"). Tooltip legend added
 * guidance wave 2026-08-25 — matches `utils.ts`'s WARN_PCT/HIGH_PCT bands (and
 * the small-absolute-kg fallback used when there's no ledger baseline to take a
 * percent against). */
export function VarianceBadge({ varianceKg, variancePct }: { varianceKg: string; variancePct: string | null }) {
  const severity = varianceSeverity(varianceKg, variancePct);
  const label = variancePct !== null ? formatPct(variancePct) : formatSignedKg(varianceKg);
  return (
    <Tooltip
      multiline
      w={280}
      label="Variance = counted (or measured) minus what the ledger says is on hand. Green: within 5% (or 50kg with no ledger baseline). Amber: 5–15%. Red: over 15%."
    >
      <Badge color={severityColor(severity)} variant="light" size="lg">
        {label}
      </Badge>
    </Tooltip>
  );
}
